module.exports = __webpack_public_path__ + "media/src/images/balloons/green_gradient-3542a337c063b66899d486d785d0a53d.jpg";